// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"_b36e3e8","vertical":"_ddea23a0","fullOpacity":"_72b1a278"};